var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWishlistHeart = function SvgIconWishlistHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14 7.747 2.18-3.096a4.667 4.667 0 0 1 8.486 2.682c0 3.839-2.612 7.496-5.81 10.448A36 36 0 0 1 14 21.528a36.082 36.082 0 0 1-4.857-3.746c-3.197-2.953-5.81-6.61-5.81-10.449a4.667 4.667 0 0 1 8.487-2.682zm-1.926-6.512A7.333 7.333 0 0 0 .666 7.333c0 10 13.333 17.314 13.333 17.314s13.334-7.314 13.334-17.314a7.333 7.333 0 0 0-13.334-4.217 7.4 7.4 0 0 0-1.925-1.881"
  })));
};
export default SvgIconWishlistHeart;